// DrmPanel.js
'use client';
import { connect } from 'react-redux';

import { goBack } from 'redux-first-history';

import recheckDrmCapability from '../action/recheckDrmCapability.js';
import toggleModal from '../action/toggleModal.js';

import {
  HELP_ARTICLE_LINK_DEVICE_INSTRUCTIONS,
  FAQ_SUPPORTED_LANGUAGES,
} from '../RemoteConfigKeys.js';

import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import getOperationData from '../selector/getOperationData.js';

import { getCurrentFaqLanguage } from '../resource/getCurrentLanguage.js';

import DrmPanel from '../page/DrmPanel.jsx';

const mapStateToProps = (state, { i18n }) => {
  const articleSupportedLanguages = getRemoteConfigData(
    state,
    FAQ_SUPPORTED_LANGUAGES
  );

  const language = getCurrentFaqLanguage({
    i18n,
    supportedLanguages: articleSupportedLanguages,
  });

  const articleDeviceInstructionsUrl = getRemoteConfigData(
    state,
    HELP_ARTICLE_LINK_DEVICE_INSTRUCTIONS,
    undefined,
    { LOWER_CASE_LANG: language }
  );
  return {
    drmTestStatus: getOperationData(state, ['drm'], 'testStatus'),
    drmTestAtUnixTimestamp: getOperationData(
      state,
      ['drm'],
      'testedAtUnixTimestamp'
    ),
    messageId: getOperationData(state, ['drm'], 'messageId'),
    swagHelpArticlesUrl: articleDeviceInstructionsUrl,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    goBack: () => dispatch(goBack()),
    recheckDrmCapability: () => dispatch(recheckDrmCapability()),
    toggleModal: data => dispatch(toggleModal(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DrmPanel);
